__turbopack_context__.v({
  "active": "NavIcon-module-scss-module__8vGHpG__active",
  "line": "NavIcon-module-scss-module__8vGHpG__line",
});
